import { render, staticRenderFns } from "./LogBox.vue?vue&type=template&id=11aea544&"
import script from "./LogBox.vue?vue&type=script&lang=js&"
export * from "./LogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports